var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8244 9.99955C23.1756 9.35077 22.1239 9.35019 21.4744 9.99827L15 16.4585L8.52564 9.99827C7.87615 9.35019 6.82443 9.35077 6.17564 9.99955C5.52635 10.6488 5.52635 11.7015 6.17564 12.3508L14.2929 20.4681C14.6834 20.8586 15.3166 20.8586 15.7071 20.4681L23.8244 12.3508C24.4736 11.7015 24.4736 10.6488 23.8244 9.99955Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownOutline);
export default __webpack_public_path__ + "static/media/down_outline.7f71ac6b96e962901a743f7be3d856a0.svg";
export { ForwardRef as ReactComponent };